(function () {
  var STORAGE_KEY = 'ui-country-banner-dismissed';
  var SNOOZE_DAYS = 30;
  var currentSuggestion = null;
  var listenersBound = false;

  function isDismissed() {
    var raw;
    try {
      raw = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return false;
    }
    if (!raw) return false;
    var dismissedAt = parseInt(raw, 10);
    if (isNaN(dismissedAt)) return false;
    var days = (Date.now() - dismissedAt) / (1000 * 60 * 60 * 24);
    return days < SNOOZE_DAYS;
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  function bindDelegatedListeners() {
    console.log('[loc-banner] bindDelegatedListeners called, already bound=', listenersBound);
    if (listenersBound) return;
    listenersBound = true;

    document.addEventListener('click', function (event) {
      console.log('[loc-banner] document click seen, target=', event.target && event.target.tagName);
      var dismissBtn = event.target.closest('.localization-suggestion-banner [data-dismiss]');
      var acceptBtn = event.target.closest('.localization-suggestion-banner [data-accept]');
      console.log('[loc-banner] dismissBtn=', !!dismissBtn, 'acceptBtn=', !!acceptBtn);

      if (dismissBtn) {
        var banner = dismissBtn.closest('.localization-suggestion-banner');
        console.log('[loc-banner] dismissing, banner found=', !!banner);
        markDismissed();
        if (banner) banner.hidden = true;
        return;
      }

      if (acceptBtn && currentSuggestion) {
        var acceptBanner = acceptBtn.closest('.localization-suggestion-banner');
        if (!acceptBanner) return;
        var countryInput = acceptBanner.querySelector('[data-country-input]');
        var form = acceptBanner.querySelector('form');
        if (countryInput && form) {
          countryInput.value = currentSuggestion.handle;
          form.submit();
        }
      }
    });
    console.log('[loc-banner] listener attached to document');
  }

  function init() {
    console.log('[loc-banner] init called');
    var banner = document.querySelector('.localization-suggestion-banner');
    if (!banner) { console.log('[loc-banner] no banner found, aborting'); return; }
    if (!window.Shopify || !window.Shopify.routes || !window.Shopify.routes.root) { console.log('[loc-banner] no Shopify.routes, aborting'); return; }
    if (isDismissed()) { console.log('[loc-banner] already dismissed, aborting'); return; }

    bindDelegatedListeners();

    var currentCountry = window.Shopify.country;
    var url =
      window.Shopify.routes.root +
      'browsing_context_suggestions.json' +
      '?country[enabled]=true' +
      '&country[exclude]=' + encodeURIComponent(currentCountry || '') +
      '&language[enabled]=false';

    fetch(url)
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (data) {
        var country = data && data.detected_values && data.detected_values.country;
        if (!country || !country.handle) { console.log('[loc-banner] no suggestion returned'); return; }

        var liveBanner = document.querySelector('.localization-suggestion-banner');
        if (!liveBanner) return;

        currentSuggestion = country;

        var messageEl = liveBanner.querySelector('[data-message]');
        var acceptEl = liveBanner.querySelector('[data-accept]');

        if (messageEl) {
          messageEl.textContent =
            "Looks like you're browsing from " + country.name + '. Switch to shop in local currency?';
        }
        if (acceptEl) {
          acceptEl.textContent = 'Switch to ' + country.name;
        }

        liveBanner.hidden = false;
        console.log('[loc-banner] banner shown for', country.name);
      })
      .catch(function (e) {
        console.log('[loc-banner] fetch error', e && e.message);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
